import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAppSelector } from '../../store/hooks';

/**
 * Keeps authenticated first-time users in onboarding, including after a refresh
 * or by entering a protected URL directly.
 */
export const OnboardingGuard: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const user = useAppSelector((s) => s.auth.user);
  const location = useLocation();
  const onboardingDone = typeof window === 'undefined'
    ? true
    : window.localStorage.getItem('onboarding_done') === 'true';

  if (user && !onboardingDone && location.pathname !== '/onboarding') {
    return <Navigate to="/onboarding" replace />;
  }

  return <>{children}</>;
};
